import React from 'react';
import PropTypes from 'prop-types';
import { CloseIconSmall } from '@domain-group/fe-co-icon';
import * as styles from './pill.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Pill = _ref => {
  var item = _ref.item,
    onRemove = _ref.onRemove;
  return ___EmotionJSX("span", {
    css: styles.pill
  }, ___EmotionJSX("span", {
    css: styles.label
  }, item.name), onRemove && ___EmotionJSX(CloseIconSmall, {
    size: "custom",
    css: styles.icon,
    onClick: event => {
      event.stopPropagation();
      onRemove(item);
    }
  }));
};
Pill.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func
};
Pill.defaultProps = {
  onRemove: undefined
};
export default Pill;